import { createUser, logIn } from "@fwa/src/services/auth";
import { Heading, Text, Box, Modal, Button } from "@cruk/cruk-react-components";

import sharedStyles from "@fwa/src/components/styles.module.css";

export function ModalNotLoggedIn({
  modalName,
  componentName,
  isNewUser,
  closeFunction,
  isTeam = false,
  isFromEmail = false,
}: {
  modalName: string;
  componentName: string;
  isNewUser: boolean;
  closeFunction: () => void;
  isTeam?: boolean;
  isFromEmail?: boolean;
}) {
  const title = isNewUser
    ? "Welcome to Online Fundraising"
    : isFromEmail
      ? isTeam
        ? "Is this your Team Page?"
        : "Is this your Giving Page?"
      : "Welcome back to Online Fundraising";
  return (
    <Modal
      closeFunction={closeFunction}
      modalName={modalName}
      showCloseButton
      data-component={componentName}
      startOpen
    >
      <Box margin="s">
        <Box paddingBottom="xxs">
          <Heading textAlign="center">{title}</Heading>
          <Text textAlign="center">
            {isNewUser
              ? `To edit your page please create an account`
              : `To edit your page please log in`}
          </Text>
        </Box>
        <Box>
          <Box>
            <div className={sharedStyles["row-center"]}>
              <Button
                appearance="primary"
                data-cta={isNewUser ? "create-account" : "log-in"}
                onClick={() => {
                  if (isNewUser) {
                    createUser();
                  } else {
                    logIn();
                  }
                }}
              >
                {isNewUser ? "Create account" : "Log in"}
              </Button>
            </div>
          </Box>
          <div className={sharedStyles["row-center"]}>
            <Button appearance="tertiary" onClick={() => closeFunction()}>
              {isNewUser ? "Maybe later" : "Dismiss"}
            </Button>
          </div>
        </Box>
      </Box>
    </Modal>
  );
}
